import React from 'react';
import {IfmsRoute} from '../../../config/types';

const Home = React.lazy(() => import('../Home'));
export const BillView = React.lazy(() => import('../bill/BillView'));
export const InvoiceView = React.lazy(() => import('../invoice/InvoiceView'));
export const CrdbView = React.lazy(() => import('../crdb/CrdbView'));
const CustomerPaymentView = React.lazy(() => import('../payments/customerPayment/CustomerPaymentView'));
const AgentPaymentView = React.lazy(() => import('../payments/agentPayment/AgentPaymentView'));
const BillPaymentView = React.lazy(() => import('../payments/billPayment/BillPaymentView'));
const CCPaymentView = React.lazy(() => import('../payments/ccPayment/CCPaymentView'));

export const GeneralInvoiceView = React.lazy(() => import("../gInvoice/GeneralInvoiceView"));
export const GeneralBillView = React.lazy(() => import("../gBill/GeneralBillView"));
const DepositCheckClearView = React.lazy(() => import("../bankTransactions/DepositCheckClear/DepositCheckClearView"));
const CreditCardClearView = React.lazy(() => import("../bankTransactions/CreditCardClear/CreditCardClearView"));
const BankReconView = React.lazy(() => import("../bankTransactions/BankRecon/BankReconView"));
const BankTransferView = React.lazy(() => import("../bankTransactions/BankTransfer/BankTransferView"));
const CheckClearWithExcelView = React.lazy(() => import("../bankTransactions/CheckClear/CheckClearWithExcelView"));
const PrepaidExpenseAdjustmentView = React.lazy(() => import("../general/prepaidExpenseAdjustment/PrepaidExpenseAdjustmentView"));
const PayrollSummaryView = React.lazy(() => import("../general/payrollSummary/PayrollSummaryView"));
const Payroll2View = React.lazy(() => import("../general/payroll2/Payroll2View"));
const DepreciationAdjustmentView = React.lazy(() => import("../general/DepreciationAdjustment/DepreciationAdjustmentView"));
const AmortizationAdjustmentView = React.lazy(() => import("../general/AmortizationAdjustment/AmortizationAdjustmentView"));
const BadDebtProcessingView = React.lazy(() => import("../general/BadDebtProcessing/BadDebtProcessingView"));
const SalesTaxReturnView = React.lazy(() => import("../general/salesTaxReturn/SalesTaxReturnView"));
const JournalView = React.lazy(() => import("../general/journal/JournalView"));
const PeriodInvoiceView = React.lazy(() => import('../invoice/NewPeriodInvoice'));
const PeriodCrdbView = React.lazy(() => import('../crdb/NewPeriodCrdb'));
const PaymentPrepView = React.lazy(() => import('../payments/paymentPrep/PaymentPrepView'));

const BusinessIntelligenceView = React.lazy(() => import('../reports/BusinessIntelligenceView'));
const DailyAccountingSummaryView = React.lazy(() => import('../reports/DailyAccountingSummaryView'));
const AgingReportView = React.lazy(() => import('../reports/AgingReportView'));
const IncomeStatementView = React.lazy(() => import('../reports/IncomeStatementView'));
const TrialBalanceView = React.lazy(() => import('../reports/TrialBalanceView'));
const BalanceSheetView = React.lazy(() => import('../reports/BalanceSheetView'));
const GeneralLedgerView = React.lazy(() => import('../reports/GeneralLedgerView'));
const AccountLedgerByEntityView = React.lazy(() => import('../reports/AccountLedgerByEntityView'));
const AccountBalanceView = React.lazy(() => import('../reports/AccountBalanceByEntityView'));
const DeferredReportView = React.lazy(() => import('../../common/reports/DeferredReportView'));
//const ProfitAndVolumeSummaryView = React.lazy(() => import('../../common/reports/ProfitAndVolumeSummaryView'));
const UndoDepositCheckClearView = React.lazy(() => import("../bankTransactions/DepositCheckClear/UndoDepositCheckClearView"));
const CancelCreditCardClearView = React.lazy(() => import('../bankTransactions/CreditCardClear/CancelCreditCardClearView'));
const PaymentHistoryView = React.lazy(() => import('../common/PaymentHistoryView'));
const BankBalanceView = React.lazy(() => import('../bankTransactions/BankBalance/BankBalanceView'));
const CustomerVendorViews = React.lazy(() => import('../reports/CustomerVendorStatementView'));
const AgentStatementView = React.lazy(() => import('../reports/AgentStatementView'));
const BatchRecogView = React.lazy(() => import('../general/BatchRecog/BatchRecogView'));

const AcctInfoView = React.lazy(() => import('../common/AcctView'));

const routes: Array<IfmsRoute> = [
  {path: '/accounting/home', component: Home},
  {path: '/accounting/bill/:mode/:parent/:parentId/:id?/:createEntity?', component: BillView},
  {path: '/accounting/invoice/:mode/:parent/:parentId/:id?/:createEntity?', component: InvoiceView},
  {path: '/accounting/periodInvoice/:mode/:id?/:createEntity?', component: PeriodInvoiceView},
  {path: '/accounting/periodCrdb/:mode/:id?/:createEntity?', component: PeriodCrdbView},
  {path: '/accounting/crdb/:mode/:parent/:parentId/:id?/:createEntity?', component: CrdbView},
  {path: '/accounting/acCustomerPayment/:mode/:id?/:createEntity?', component: CustomerPaymentView},
  {path: '/accounting/acAgentPayment/:mode/:id?', component: AgentPaymentView},
  {path: '/accounting/acBillPayment/:mode/:id?/:createEntity?', component: BillPaymentView},
  {path: '/accounting/acCCPayment/:mode/:id?', component: CCPaymentView},
  {path: '/accounting/acGeneralInvoice/:mode/:id?/:createEntity?', component: GeneralInvoiceView},
  {path: '/accounting/acGeneralBill/:mode/:id?/:createEntity?', component: GeneralBillView},
  {path: '/accounting/acDepositCheckClear/:mode/:id?', component: DepositCheckClearView},
  {path: '/accounting/acCreditCardClear/:mode/:id?', component: CreditCardClearView},
  {path: '/accounting/acBankRecon/:mode/:id?', component: BankReconView},
  {path: '/accounting/acBankTransfer/:mode/:id?', component: BankTransferView},
  {path: '/accounting/acCheckClear/:mode/:id?', component: CheckClearWithExcelView},
  {path: '/accounting/acPrepaidExpenseAdjustment/:mode/:id?', component: PrepaidExpenseAdjustmentView},
  {path: '/accounting/acPayrollSummary/:mode/:id?', component: PayrollSummaryView},
  {path: '/accounting/acPayroll2/:mode/:id?/:createEntity?', component: Payroll2View},
  {path: '/accounting/acDepreciationAdjustment/:mode/:id?', component: DepreciationAdjustmentView},
  {path: '/accounting/acAmortizationAdjustment/:mode/:id?', component: AmortizationAdjustmentView},
  {path: '/accounting/acBadDebtProcessing/:mode/:id?', component: BadDebtProcessingView},
  {path: '/accounting/acSalesTaxReturn/:mode/:id?', component: SalesTaxReturnView},
  {path: '/accounting/acJournal/:mode/:fkey/:seq/:type/:tbType?', component: JournalView},
  {path: '/accounting/acPaymentPrep/:mode/:id?', component: PaymentPrepView},
  {path: '/accounting/acPaymentHistoryView/:jobName/:jobId/:parent?', component: PaymentHistoryView},
  {path: '/accounting/acBankBalanceView', component: BankBalanceView},

  {path: '/accounting/acBusinessIntelligence', component: BusinessIntelligenceView},
  {path: '/accounting/acDailyAccountingSummary', component: DailyAccountingSummaryView},
  {path: '/accounting/acAging', component: AgingReportView},
  {path: '/accounting/acIncomeStatement', component: IncomeStatementView},
  {path: '/accounting/acBalanceSheet', component: BalanceSheetView},
  {path: '/accounting/acTrialBalance', component: TrialBalanceView},
  {path: '/accounting/acGeneralLedger', component: GeneralLedgerView},
  {path: '/accounting/acAccountLedger', component: AccountLedgerByEntityView},
  {path: '/accounting/acAccountBalance', component: AccountBalanceView},
  {path: '/accounting/acDeferredReport', component: DeferredReportView},
  {path: '/accounting/acDepositCheckClear', component: DepositCheckClearView},
  {path: '/accounting/acUndoDepositCheckClear', component: UndoDepositCheckClearView},
  {path: '/accounting/acCreditCardClear', component: CreditCardClearView},
  {path: '/accounting/acCancelCreditCardClear', component: CancelCreditCardClearView},
  {path: '/accounting/acCheckClearwExcel', component: CheckClearWithExcelView},
  {path: '/accounting/acCustomerStatement', component: CustomerVendorViews},
  {path: '/accounting/acAgentStatement', component: AgentStatementView},
  {path: '/accounting/acSalesCostRecog/:mode/:id?', component: BatchRecogView},

  {path: '/accounting/Acct/:parent/:parentId', component: AcctInfoView},
];

export default routes;
